import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService, EventService } from '@pos-app/core-ui';
import { Subject, BehaviorSubject } from 'rxjs';
import { OrderForBooking, JobGroup } from '@pos-app/data';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CDK_DRAG_CONFIG, CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { MontlyDateArray } from '../../orders/+state/orders.models';
import moment from 'moment';

const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 10000,
};
@Component({
    selector: 'app-splitorder',
    styleUrls: ['./splitorder.component.css'],
    templateUrl: './splitorder.component.html',
    providers: [{ provide: CDK_DRAG_CONFIG, useValue: DragConfig }],
    standalone: false
})
export class SplitOrderContent implements OnInit {
  @ViewChild('d') d2: NgbInputDatepicker;
  @Input() unAssignedOrdersList: JobGroup[];
  @Input() selectedOrder;
  @Input() selectedOrderType;
  @Input() currentDate;
  @Input() defaultBranch;
  private unSubscribe$ = new Subject<void>();
  dragDropUniqueIds: Map<string, string[]>;
  ordersForBooking: OrderForBooking[];
  assignedOrdersForScheduler: Map<string, OrderForBooking[]>;
  arrayOfLineOrderNumber: string;
  arrayOfLineFromGroupName: string;
  arrayOfLineLineNumber: string;
  originalStandardHours: number;
  totalStandardHorus: number;
  totalScheduledHours: number;
  orderLineMoved: Boolean = false;
  splitValid: Boolean = false;
  autoSplitTF: boolean = false;
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  previousDate: string;
  dayDetails: Array<MontlyDateArray> = [];
  selectedFitDays: Array<string> = [];
  fitDays: number;
  fitHours: number;
  dateNgbDateStruct: any;
  splitFormGroup: UntypedFormGroup;
  formGroup: UntypedFormGroup;
  previousDateForCalander: string;
  mulitSelectedList: Array<any> = [];
  currentMonth: number;


  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private eventService: EventService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private renderer: Renderer2
  ) {
    this.formGroup = this.formBuilder.group({
      jobGroup: this.formBuilder.array([]),
    });
  }

  ngOnInit() {
    this.initSplitOrders();
    this.totalScheduledHours = this.unAssignedOrdersList?.reduce((a, b) => a + b.scheduledHours, 0);
    this.totalStandardHorus = this.unAssignedOrdersList?.reduce((a, b) => a + b.standardHours, 0);
  }

  initSplitOrders() {
    if (this.formGroup.get('jobGroup')?.value) {
      this.formGroup.reset();
      (this.formGroup.get('jobGroup') as UntypedFormArray).clear();
    }
    this.addIndex();

    const jobGroup = this.unAssignedOrdersList;
    jobGroup.forEach((jobGroup, index) => {
      (this.formGroup.get('jobGroup') as UntypedFormArray).push(this.thingFormGroup(this.formBuilder, index, false));
    });
    this.formGroup.patchValue({
      jobGroup,
    });
  }

  thingFormGroup(formBuilder, index, addNewEmptyGroup = false) {
    if (addNewEmptyGroup) {
      const val = [{}];
      this.splitValid = true;
      return formBuilder.group({
        index: [index],
        jobID: [0],
        jobSplitNum: [],
        standardHours: [0],
        scheduledHours: [0],
        description: [this.unAssignedOrdersList[0].description],
        fitDate: [this.currentDate, Validators.required],
        allocatedTF: [false],
        orderLines: [[...val]],
      });
    } else {
      return formBuilder.group({
        index: [index],
        jobID: [],
        jobSplitNum: [],
        standardHours: [],
        scheduledHours: [],
        description: [],
        fitDate: ['', Validators.required],
        allocatedTF: [],
        orderLines: [],
      });
    }
  }

  remove(formGroup: UntypedFormGroup, index) {
    const selectedJob = this.formGroup.get('jobGroup').value[index];
    if (selectedJob?.orderLines.length > 0) {
      this.confirmationService.confirm({
        message: 'Parts must be empty before deleting the split',
        key: 'splitInvalidDelete',
        accept: () => {},
      });
    } else {
      (this.formGroup.get('jobGroup') as UntypedFormArray).removeAt((this.formGroup.get('jobGroup') as UntypedFormArray).controls.indexOf(formGroup));
      //update uid
      this.formGroup.get('jobGroup').value.map((el, index) => (el.orderLines['uid'] = index));
      this.setNewSplitNum();
      this.reCalculateHours();
    }
  }

  drop(event: CdkDragDrop<{}[]>) {
    if (event.previousContainer == event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const currentBoxIndex = event.container.data['uid'];
      const previousBoxIndex = event.previousContainer.data['uid'];
      if (this.mulitSelectedList.length > 1) {
        //adding to new group
        for (let i = 0; i < this.mulitSelectedList.length; i++) {
          this.formGroup.controls['jobGroup']['controls'][currentBoxIndex].patchValue({
            description: this.formGroup.get('jobGroup').value[previousBoxIndex]?.description,
            standardHours: (this.formGroup.get('jobGroup').value[currentBoxIndex]['standardHours'] ?? 0) + this.mulitSelectedList[i].item.fitHours,
            scheduledHours: (this.formGroup.get('jobGroup').value[currentBoxIndex]['scheduledHours'] ?? 0) + this.mulitSelectedList[i].item.fitHours,
          });
          //removing from previous group (multi)
          this.formGroup.controls['jobGroup']['controls'][this.mulitSelectedList[i].parentIndex].patchValue({
            standardHours: this.getResult(
              this.formGroup.get('jobGroup').value[this.mulitSelectedList[i].parentIndex]?.standardHours,
              this.mulitSelectedList[i].item.fitHours
            ),

            scheduledHours: this.getResult(
              this.formGroup.get('jobGroup').value[this.mulitSelectedList[i].parentIndex]?.scheduledHours,
              this.mulitSelectedList[i].item.fitHours
            ),
          });
          transferArrayItem(
            this.formGroup.get('jobGroup').value[this.mulitSelectedList[i].parentIndex].orderLines,
            this.formGroup.get('jobGroup').value[currentBoxIndex].orderLines,
            this.formGroup
              .get('jobGroup')
              .value[this.mulitSelectedList[i].parentIndex].orderLines.map((e) => e.lineNumber)
              .indexOf(this.mulitSelectedList[i].childLineNumber),
            this.formGroup.get('jobGroup').value[currentBoxIndex].orderLines.length
          );
        }
      } else {
        if (event.container.data.length === 0) {
          //adding to new group

          this.formGroup.controls['jobGroup']['controls'][currentBoxIndex].patchValue({
            description: this.formGroup.get('jobGroup').value[previousBoxIndex]?.description,
            standardHours: this.formGroup.get('jobGroup').value[previousBoxIndex]?.orderLines.filter((el, index) => index === event.previousIndex)[0][
              'fitHours'
            ],
            scheduledHours: this.formGroup
              .get('jobGroup')
              .value[previousBoxIndex]?.orderLines.filter((el, index) => index === event.previousIndex)[0]['fitHours'],
          });
          //removing from previous group (single and when )

          this.formGroup.controls['jobGroup']['controls'][previousBoxIndex].patchValue({
            standardHours: this.getResult(
              this.formGroup.get('jobGroup').value[previousBoxIndex]?.standardHours,
              event.previousContainer.data[event.previousIndex]['fitHours']
            ),
            scheduledHours: this.getResult(
              this.formGroup.get('jobGroup').value[previousBoxIndex]?.scheduledHours,
              event.previousContainer.data[event.previousIndex]['fitHours']
            ),
          });

          this.setNewSplitNum();
        } else {
          //adding to new group
          this.formGroup.controls['jobGroup']['controls'][currentBoxIndex].patchValue({
            standardHours:
              event.previousContainer.data[event.previousIndex]['fitHours'] +
              this.formGroup.get('jobGroup').value[event.container.data['uid']].standardHours,
            scheduledHours:
              event.previousContainer.data[event.previousIndex]['fitHours'] +
              this.formGroup.get('jobGroup').value[event.container.data['uid']].scheduledHours,
          });
          //removing from previous group

          this.formGroup.controls['jobGroup']['controls'][previousBoxIndex].patchValue({
            standardHours: this.getResult(
              this.formGroup.get('jobGroup').value[previousBoxIndex]?.standardHours,
              event.previousContainer.data[event.previousIndex]['fitHours']
            ),
            scheduledHours: this.getResult(
              this.formGroup.get('jobGroup').value[previousBoxIndex]?.scheduledHours,
              event.previousContainer.data[event.previousIndex]['fitHours']
            ),
          });

          this.setNewSplitNum();
        }
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
      this.mulitSelectedList = [];
      this.uncheckAll();
      this.setNewSplitNum();
      this.splitValid = true;
      this.orderLineMoved = true;
    }
  }
  getResult(a, b) {
    const val = Math.round((a - b) * 100) / 100;
    return val > 0 ? val : 0;
  }
  uncheckAll() {
    // Select all checkboxes
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    // Loop through each checkbox and uncheck it
    checkboxes.forEach(function (checkbox) {
      (checkbox as HTMLInputElement).checked = false;
    });
  }

  submitSplitOrder(status) {
    this.loading = true;
    if (!status) {
      return;
    }
    const splitOrderArray = this.formGroup.get('jobGroup').value.map((el) => {
      return {
        jobID: el.jobID,
        description: el.description,
        jobSplitNum: el.jobSplitNum,
        standardHours: el.standardHours ?? 0,
        scheduledHours: el.scheduledHours ?? 0,
        fitDate: el.fitDate,
        lineNumberArray: el?.orderLines?.map((elsub) => {
          return { lineNumber: elsub.lineNumber, fitHours: elsub.fitHours };
        }),
      };
    });

    if (status && this.unAssignedOrdersList) {
      this.eventService
        .splitOrderV2({
          orderNumber: this.selectedOrder.OrderNumber,
          orderType: this.selectedOrder?.OrderType,
          splitOrderArray: splitOrderArray,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data) this.activeModal.close(true);
        });
      this.loading = false;
    } else {
      this.activeModal.close(false);
      this.unAssignedOrdersList = [];
    }
  }

  onChangeDescription(e, index) {
    this.formGroup.get('jobGroup').value[index]['description'] = e.target.value;
    this.splitValid = true;
  }
  onChangeScheduledHours(e, index) {
    this.formGroup.get('jobGroup').value[index]['scheduledHours'] = Number(e.target.value);
    this.totalScheduledHours = this.formGroup.get('jobGroup').value?.reduce((a, b) => a + b.scheduledHours, 0);
    this.splitValid = true;
  }
  checkAllowEditable(event) {
    event.preventDefault();
    return false;
  }
  resetSplitOrders() {
    this.autoSplitTF = false;
    this.eventService
      .fetchOrderDetailsForSplit({
        jobID: this.selectedOrder?.JobID,
        autoSplitTF: false,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          this.unAssignedOrdersList = data?.response?.jobGroup;
          this.initSplitOrders();
        }
      });
    this.orderLineMoved = false;
  }

  autoSplit() {
    if (this.orderLineMoved) {
      this.confirmationService.confirm({
        message: 'This will replace the current splits made',
        key: 'overCurrentSplitConfirmation',
        accept: () => {
          this.performAutoSplit();
        },
      });
    } else {
      this.performAutoSplit();
    }
  }
  performAutoSplit() {
    this.loading = true;
    this.eventService
      .fetchOrderDetailsForSplit({
        jobID: this.selectedOrder.JobID,
        autoSplitTF: true,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data) {
          const jobGroupArray = data?.response.jobGroup.map((el, index) => {
            el['index'] = index;
            el.orderLines['uid'] = index;
            return el;
          });
          let newArray = [];
          let index = 0;
          for (let i = 0; i < jobGroupArray.length; i++) {
            newArray.push(jobGroupArray[index]);
            index++;
          }
          this.unAssignedOrdersList = newArray;
          this.orderLineMoved = true;
          this.autoSplitTF = true;
          this.splitValid = true;
          this.loading = false;
          this.initSplitOrders();
        }
      });
  }

  addNewEmptyGroup() {
    (this.formGroup.get('jobGroup') as UntypedFormArray).push(this.thingFormGroup(this.formBuilder, this.formGroup.get('jobGroup').value.length, true));

    this.formGroup.get('jobGroup').value[this.formGroup.get('jobGroup').value.length - 1]['orderLines']['uid'] =
      this.formGroup.get('jobGroup').value.length - 1;
    this.formGroup
      .get('jobGroup')
      .value[this.formGroup.get('jobGroup').value.length - 1].orderLines.splice(
        this.formGroup.get('jobGroup').value[this.formGroup.get('jobGroup').value.length - 1],
        1
      );
    this.setNewSplitNum();
  }

  setNewSplitNum() {
    this.formGroup.get('jobGroup').value.forEach((el, index) => {
      this.formGroup.controls['jobGroup']['controls'][index].patchValue({
        jobSplitNum: index + 1 + '/' + this.formGroup.get('jobGroup').value.length,
      });
    });
  }
  cancelOrDelete(index) {
    const selectedJob = this.formGroup.get('jobGroup').value[index];
    const originalJob = this.formGroup.get('jobGroup').value?.filter((el) => el.jobID === this.formGroup.get('jobGroup').value[index]?.indexJobID)[0];
    this.unAssignedOrdersList = this.unAssignedOrdersList.filter((el, i) => index !== i);
    if (selectedJob?.orderLines.length > 0) {
      selectedJob?.orderLines?.map((el) => {
        originalJob.orderLines.push({ string: el.string, lineNumber: el.lineNumber, ooeLineNumber: el.ooeLineNumber, fitHours: el.fitHours });
      });
      this.unAssignedOrdersList[originalJob.index]['orderLines'] = originalJob.orderLines;
      this.unAssignedOrdersList[originalJob.index]['standardHours'] =
        this.unAssignedOrdersList[originalJob.index]['standardHours'] + selectedJob.standardHours;
      this.unAssignedOrdersList[originalJob.index]['scheduledHours'] =
        this.unAssignedOrdersList[originalJob.index]['scheduledHours'] + selectedJob.standardHours;
    }

    this.setNewSplitNum();
    this.reCalculateHours();
  }
  //check if valid split afte deleting
  checkIfValidSplit() {
    if (
      this.unAssignedOrdersList.filter((el, index) => el.orderLines.length > 0).length < 2 ||
      this.unAssignedOrdersList.filter((el, index) => el.orderLines.length < 1).length > 0
    ) {
      this.splitValid = false;
    } else {
      this.splitValid = true;
    }
  }
  reCalculateHours() {
    this.unAssignedOrdersList.map((el, index) => {
      el.orderLines.map((elsub, index) => {});
    });
  }

  showDetails = (d: NgbDateStruct, index, datepicker) => {
    let date: any;
    let month: any;
    if (d.day?.toString().length < 2) {
      date = '0' + d.day.toString();
    } else {
      date = d.day.toString();
    }
    if (d.month.toString().length < 2) {
      month = '0' + d.month.toString();
    } else {
      month = d.month.toString();
    }
    const selectedDay = date + '/' + month + '/' + d.year.toString();
    if (this.dayDetails.some((el) => el.date === selectedDay)) {
      setTimeout(() => {
        this.formGroup.controls['jobGroup']['controls'][index].patchValue({
          fitDate: selectedDay.toString(),
        });
      }, 100);

      datepicker.close();
      this.splitValid = true;
    } else {
      this.formGroup.controls['jobGroup']['controls'][index].patchValue({
        fitDate: this.previousDateForCalander,
      });
    }
  };
  navigateCalendar(event, index) {
    this.currentMonth = event.next.month;
    let x = document.querySelectorAll('.ngb-dp-day');
    setTimeout(() => {
      if (x[0]?.getAttribute('aria-label') && x[x.length - 1]?.getAttribute('aria-label')) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label')),
          this.formGroup.get('jobGroup').value[index].scheduledHours
        );
      }
    }, 100);
  }
  isDisabled = (date: NgbDateStruct, current: { month: number; year: number }) => {
    return current.month !== date.month;
  };
  fetchMonthlyViewForOrder(startDate, endDate, scheduledHours) {
    this.apiService
      .fetchMonthlyViewForOrder({
        startDate: startDate,
        endDate: endDate,
        orderNumber: this.selectedOrder?.OrderNumber.toString(),
        branch: this.defaultBranch,
        scheduledHours: scheduledHours,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        if (res) {
          this.dayDetails = res?.dates;
          this.dayDetails = [res?.dates, ...this.dayDetails];
          this.fitDays = res?.fitDays;
          this.fitHours = res?.fitHours;
          const value = this.dayDetails.map((el) => {
            return el.date;
          });
          // this.setDisableDate(value);
          // this.d2.open();
          setTimeout(() => {
            this.displayMonth(res?.dates, res?.fitDays, res?.fitHours);
          }, 100);
        }
      });
  }
  displayMonth(dates, fitDays, fitHours) {
    //remove latest custom Header on calendar
    if (document.querySelectorAll('.ngb-dp-week-label-custom-header').length > 0) {
      const elements = document.querySelectorAll('.ngb-dp-week-label-custom-header');
      elements.forEach((element) => {
        element.remove();
      });
    }


    let x = document?.querySelectorAll('.ngb-dp-day');
    x?.forEach((y) => {
      if (y.getAttribute('aria-label')) {
        const dateSearch = this.dateToString(y.getAttribute('aria-label'));
        if (Number(dateSearch.split('/')[1]) === this.currentMonth) {
          const data = dates.find((f) => f.date === dateSearch);
          if (data) {
            if (data?.ATPErrorTF) {
              document.getElementById(y.children[0].children[0].id).className = 'atpErrorTFCss';
            } else if (data?.fullyBookedTF) {
              document.getElementById(y.children[0].children[0].id).className = 'fullyBookedTFCss';
            } else if (data?.partialSpaceTF) {
              document.getElementById(y.children[0].children[0].id).className = 'partialSpaceTFCss';
            } else if (data?.spaceAvailable) {
              document.getElementById(y.children[0].children[0].id).className = 'spaceAvailableCss';
            } else {
              document.getElementById(y.children[0].children[0].id).className = 'disabled';
            }
            document.getElementById(y.children[0].children[1].id).innerHTML =
              (data.totalHoursAvail - data?.bookedHours).toFixed(2).toString() + ' hrs';
            document
              .getElementById(y.children[0].children[0].id)
              .setAttribute('title', `Booked Hrs: ${data?.bookedHours}\nBooked: ${data?.bookedPerc}%`);
          } else {
            document.getElementById(y.children[0].children[1].id).innerHTML = '';
            y.classList.add('customCss');
            document.getElementById(y.children[0].children[0].id).className = 'disabled';
          }
          const selectedDaysData = this.selectedFitDays.find((f) => f == dateSearch);
          if (selectedDaysData) {
            document.getElementById(y.children[0].children[0].id).className = 'selectedFittingDateCss';
          }
        }
      }
    });
  }
  dateToString(date: any) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }
  streamOpened(event, index) {
    this.previousDateForCalander = this.formGroup.get('jobGroup').value[index]['fitDate'];

    document.querySelectorAll('.ngb-dp-month').forEach((el) => {
      el.className = 'ngb-dp-month-custom';
    });
    document.querySelectorAll('.ngb-dp-weekdays').forEach((el) => {
      el.className = 'ngb-dp-week ngb-dp-weekdays ng-star-inserted ngb-dp-weekdays-custom';
    });
    document.querySelectorAll('.ngb-dp-week').forEach((el, i) => {
      if (i === 0) {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-label-custom';
      } else {
        el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-custom';
      }
    });
    document.querySelectorAll('.ngb-dp-day.ng-star-inserted').forEach((el) => {
      el.className = 'ngb-dp-day ng-star-inserted ngb-dp-day-custom';
    });
    let x = document.querySelectorAll('.ngb-dp-day');
    if (this.dateToString(x[0]?.getAttribute('aria-label')) && this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))) {
      this.fetchMonthlyViewForOrder(
        this.dateToString(x[0]?.getAttribute('aria-label')),
        this.dateToString(x[x.length - 1]?.getAttribute('aria-label')),
        this.formGroup.get('jobGroup').value[index].scheduledHours
      );
    }
  }
  multiSelect(parentIndex, childIndex, item, check) {
    if (check) {
      this.mulitSelectedList.push({ parentIndex: parentIndex, childIndex: childIndex, item: item, childLineNumber: item.lineNumber });
    } else {
      this.mulitSelectedList = this.mulitSelectedList.filter((el) => el.parentIndex === parentIndex && el?.childIndex !== childIndex);
    }
  }

  addIndex() {
    this.unAssignedOrdersList.map((el, i) => {
      el['index'] = i;
      el.orderLines['uid'] = i;
      el.orderLines.map((subel) => (subel['jobUid'] = el.jobID));
    });
  }

  getToday() {
    return moment(new Date(), 'dd/mm/yyyy');
  }
}

